<template>
    <div>

        <!-- Behavioral indicators modal -->

        <trax-ui-modal-default :id="behavioural_indicator_id" :bus="bus" size="lg" no-header="1">
            <trax-ui-vertical-dynamic-tabs :tabs="flight_phases_select" :id="behavioural_indicator_id+'-tabs'" :bus="bus" class="pb-3 pt-3">
                <enac-custom-atpl-assessment-edit-index-struct :id="behavioural_indicator_id" :toastr-id="toastrId" :bus="bus" 
                    :index-id="behaviouralIndicatorsIndexId" with-tags="1"
                    :learning-unit-id="learningUnitId">
                </enac-custom-atpl-assessment-edit-index-struct>
            </trax-ui-vertical-dynamic-tabs>
        </trax-ui-modal-default>

        <!-- General criteria modal -->

        <trax-ui-modal-default :id="general_criteria_id" :bus="bus" size="lg" no-header="1">
            <trax-ui-vertical-dynamic-tabs :tabs="competency_domains_select" :id="general_criteria_id+'-tabs'" :bus="bus" class="pb-3 pt-3">
                <enac-custom-atpl-assessment-edit-index-struct :id="general_criteria_id" :toastr-id="toastrId" :bus="bus" 
                    :index-id="generalCriteriasIndexId"
                    :learning-unit-id="learningUnitId">
                </enac-custom-atpl-assessment-edit-index-struct>
            </trax-ui-vertical-dynamic-tabs>
        </trax-ui-modal-default>

        <!-- Assessment guide modal -->

        <trax-ui-modal-default :id="assessment_guide_id" :bus="bus" :title="lang.polaris.common.assessment_guide">
            <enac-custom-atpl-assessment-edit-guide :id="assessment_guide_id" :learning-unit-id="learningUnitId" :bus="bus">
            </enac-custom-atpl-assessment-edit-guide>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="toastrId" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {
    
        props: {
            toastrId: {default: 'enac-custom-atpl-assessment-toastr'},
            behavioural_indicator_id: {default: 'enac-custom-atpl-assessment-behavioural-indicator-index'},
            general_criteria_id: {default: 'enac-custom-atpl-assessment-general-criteria-index'},
            assessment_guide_id: {default: 'enac-custom-atpl-assessment-assessment-guide'},
            behaviouralIndicatorsIndexId: null,
            generalCriteriasIndexId: null,
            learningUnitId: null,
        },
    
        data: function() {
            return {
                lang: lang,
                flight_phases_select: data.flight_phases_select,
                competency_domains_select: data.competency_domains_select,
                bus: this.$bus
            }
        }
    }
</script>
